import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "project-window-help" }
const _hoisted_2 = { class: "popup-content-lower" }
const _hoisted_3 = { class: "list-help usn" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "row-help" }
const _hoisted_6 = { class: "text-area" }
const _hoisted_7 = { class: "subtext" }
const _hoisted_8 = {
  class: "help-links",
  target: "_blank",
  rel: "noopener",
  href: "https://join.slack.com/t/superthreadcommunity/shared_invite/zt-z0inhlyc-ifhwtGUNBM1G~z2NkMJIPg"
}
const _hoisted_9 = { class: "row-help" }
const _hoisted_10 = { class: "text-area" }
const _hoisted_11 = { class: "subtext" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "row-help" }
const _hoisted_14 = { class: "text-area" }
const _hoisted_15 = { class: "subtext" }
const _hoisted_16 = { class: "row-help" }
const _hoisted_17 = { class: "text-area" }
const _hoisted_18 = { class: "mail-section" }
const _hoisted_19 = { class: "subtext" }

import { getCurrentInstance, onMounted, computed } from 'vue';
import { Portal } from 'portal-vue';
import { useConfirmDialog } from '@vueuse/core';
import ConfirmationModal from '@/components/widgets/ConfirmationModal.vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useTranslate from '@/utilities/composables/useTranslate';
import useNotes from '@/utilities/composables/useNotes';
import useIsElectronApp from '@/utilities/composables/useIsElectronApp';


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpPopup',
  setup(__props) {

const { iconPath, getCustomIconStyle } = useCustomIcon();
const { translate } = useTranslate();
const _this = getCurrentInstance()!.proxy as any;
const confirmDialog = useConfirmDialog();
const { createNoteFromOnboardingEvent } = useNotes();
const { isElectronApp } = useIsElectronApp();

onMounted(() => {
  confirmDialog.reveal();
  confirmDialog.onCancel((e: Event) => {
    closeHelpPopup(e);
  });
});

const onboardingSections = computed(() => {
  return [
    {
      title: translate('quickStart'),
      description: translate('getToKnow'),
      icon: 'zap',
      show: true,
      onClick: openOnboarding,
    },
    {
      title: translate('notesTutorial'),
      description: translate('learnHowToUseSuperthreadNotes'),
      icon: 'note',
      show: isElectronApp.value,
      onClick: openNotesTutorial,
    },
  ];
});

const onboardingSectionsToShow = computed(() => {
  return onboardingSections.value.filter((section) => section.show);
});

const openOnboarding = () => {
  _this.$store.dispatch('setShowOnboarding', true);
};

const openNotesTutorial = () => {
  closeHelpPopup();
  createNoteFromOnboardingEvent();
};

const closeHelpPopup = (event: Event) => {
  const { target } = event || {};

  if (target && (target as HTMLElement).matches('.ui-notification-text-wrap .close-icon')) {
    return;
  }
  _this.$store.dispatch('setHelpPopupIsOn', false);
};

const openMailClient = () => {
  const mailtoLink = `mailto:${_this.$constants.contactMail}`;
  window.location.href = mailtoLink;
};

const copyToClipboard = (event: Event, text: string) => {
  event.stopPropagation();
  navigator.clipboard.writeText(text);
  const notification = {
    message: translate('mailCopiedToClipboard'),
    icon: 'link-st',
    duration: 4000,
  };
  _this.$store.dispatch('addUiNotification', notification);
};

return (_ctx: any,_cache: any) => {
  return (_unref(confirmDialog).isRevealed.value)
    ? (_openBlock(), _createBlock(_unref(Portal), {
        key: 0,
        to: "root-widget"
      }, {
        default: _withCtx(() => [
          _createVNode(ConfirmationModal, {
            title: _unref(translate)('helpFeedback'),
            "header-icon": 'help-circle',
            "confirm-button-text": _unref(translate)('duplicate'),
            "show-confirm-buttons": false,
            "width-class": 'w-[450px]',
            onCancel: closeHelpPopup
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "popup-content" }, [
                  _createElementVNode("div", { class: "video-wrap usn" }, [
                    _createElementVNode("iframe", {
                      width: "452",
                      height: "255",
                      src: "https://www.youtube.com/embed/fWQxk_5lfjI?rel=0&color=white",
                      title: "YouTube video",
                      allow: "accelerometer; autoplay; clipboard-write;\n                encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: "allowfullscreen"
                    })
                  ])
                ], -1)),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(onboardingSectionsToShow.value, (section) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: section.title,
                        class: "help-links",
                        onClick: section.onClick
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("em", {
                            class: "help-icon",
                            style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(section.icon)))
                          }, null, 4),
                          _cache[2] || (_cache[2] = _createTextVNode()),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("strong", null, _toDisplayString(section.title), 1),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(section.description), 1)
                          ]),
                          _cache[3] || (_cache[3] = _createTextVNode()),
                          _createElementVNode("em", {
                            class: "custom-icons arrow-right",
                            style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('chevron-right')))
                          }, null, 4)
                        ])
                      ], 8, _hoisted_4))
                    }), 128)),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    _createElementVNode("a", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("em", {
                          class: "help-icon",
                          style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('slack')))
                        }, null, 4),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)('joinSlack')), 1),
                          _cache[4] || (_cache[4] = _createTextVNode()),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(translate)('askQuestions')), 1)
                        ]),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("em", {
                          class: "custom-icons arrow-right",
                          style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('chevron-right')))
                        }, null, 4)
                      ])
                    ]),
                    _cache[15] || (_cache[15] = _createTextVNode()),
                    _createElementVNode("a", {
                      target: "_blank",
                      rel: "noopener",
                      class: "help-links",
                      href: _ctx.$constants.changelogUrl
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("em", {
                          class: "help-icon",
                          style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('rocket')))
                        }, null, 4),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)('whatsNew')), 1),
                          _cache[7] || (_cache[7] = _createTextVNode()),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(translate)('viewUpdates')), 1)
                        ]),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        _createElementVNode("em", {
                          class: "custom-icons arrow-right",
                          style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('chevron-right')))
                        }, null, 4)
                      ])
                    ], 8, _hoisted_12),
                    _cache[16] || (_cache[16] = _createTextVNode()),
                    _createElementVNode("div", {
                      class: "help-links",
                      onClick: openMailClient
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("em", {
                          class: "help-icon",
                          style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('mail')))
                        }, null, 4),
                        _cache[12] || (_cache[12] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)('contactUs')), 1),
                          _cache[11] || (_cache[11] = _createTextVNode()),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$constants.contactMail), 1),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createElementVNode("div", {
                              class: "copy-icon-box",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard($event, _ctx.$constants.contactMail)))
                            }, [
                              _createElementVNode("em", {
                                class: "copy-mail-icon",
                                style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('copy')))
                              }, null, 4)
                            ])
                          ])
                        ]),
                        _cache[13] || (_cache[13] = _createTextVNode()),
                        _createElementVNode("em", {
                          class: "custom-icons arrow-right",
                          style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)('chevron-right')))
                        }, null, 4)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title", "confirm-button-text"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})